import { render, staticRenderFns } from "./Selfhelp.vue?vue&type=template&id=425489f8"
import script from "./Selfhelp.vue?vue&type=script&lang=js"
export * from "./Selfhelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports